export enum Pricing {
  Static = 'STATIC',
  RateCard = 'RATE_CARD',
}
